@if (isTestProcess()) {
  @if (variant() === "banner") {
    <p-message severity="warn" icon="pi pi-exclamation-triangle">{{ description() }}</p-message>
  } @else {
    <p-tag severity="warn" icon="pi pi-exclamation-triangle" [value]="label()" [pTooltip]="description()" />
  }
}
